module.exports = __webpack_public_path__ + "static/media/dark.f3609bd2.png";